/*
 *@Description: 布控管理-表格列配置
 *@Author: zhengff
 *@Date: 2019-04-26 21:55:36
*/
import {Dic} from '$utils'
import i18n from '@src/common/lib/i18n'
export const tableColumn =() =>{
  return [
  {
    label: i18n.t('carPatrol.label.name'),
    prop: 'name',
    align: 'center',
    overHidden: true
  },
  {
    label: i18n.t('carPatrol.label.state'),
    prop: 'status',
    // width:100,
    align: 'center',
    formatter:function(row,value){
      if(value == 1){
        return i18n.t('carPatrol.button.Enabled')
      }
      if(value == 2){
        return i18n.t('carPatrol.button.Disabled')
      }
      if(value == 3){
        return i18n.t('carPatrol.button.Disabled')
      }
    }
  },
  // {
  //   label: i18n.t('carPatrol.label.time'),
  //   prop: 'timelist',
  //   align:'center',
  //   width:350,
  //   formatter:function(row,value){
  //     return row.startDate + i18n.t('carPatrol.label.to') +  row.endDate
  //   }
  // },
  // {
  //   label: i18n.t('carPatrol.label.type'),
  //   prop: 'type',
  //   overHidden: true,
  //   align: 'center',
  //   formatter: function(row, value) {
  //     if (value == 2) {
  //       return i18n.t('carPatrol.label.blacklist')
  //     }else{
  //       return i18n.t('carPatrol.label.blacklist')
  //     }
  //   }
  // },
  {
    label: i18n.t('布控对象'),
    prop: 'creator',
    align: 'center',
    formatter:function(row,value){
      console.log('row',row);
      return row.groupList[0].repositoriesName
    }
  },
  {
    label: i18n.t('摄像机组'),
    prop: 'creator',
    align: 'center',
    formatter:function(row,value){
      let str = ''
      row.bayonetList.map((val,index)=>{
        if (index == row.bayonetList.length-1) {
          str += val.bayonetName
        }else{
          str += val.bayonetName+','
        }
      });
      return (
        str
        
      )
    }
  },
  // {
  //   label: i18n.t('carPatrol.label.state'),
  //   prop: 'status',
  //   width:100,
  //   align: 'center',
  //   formatter:function(row,value){
  //     if(value == 1){
  //       return i18n.t('carPatrol.button.Enabled')
  //     }
  //     if(value == 2){
  //       return i18n.t('carPatrol.button.Disabled')
  //     }
  //     if(value == 3){
  //       return i18n.t('carPatrol.button.Disabled')
  //     }
  //   }
  // }
]
}